export default {
  meta: {
    title: '门店预测',
    url: '/predict', // 埋点用，记录所属模块
    // eventId: '422c8c0f-1a47-47ac-908f-b3cd9544ae11'
  },
};
